import { defineStore } from 'pinia'
import { request } from '../../api'

export const useSurfaceDesignPrintsStore = defineStore('surfaceDesignPrints', {
  state: () => ({
    list: null,
    count: -1,
    items: null,
    itemsCount: -1,
    collectionsParams: {
      limit: 20,
      offset: 0,
      q: '',
      personal: 1,
      sortDirection: 'asc',
      sortField: 'updatedAt',
    },
    itemsParams: {
      limit: 20,
      offset: 0,
      q: '',
      sortDirection: 'asc',
      sortField: 'updatedAt',
      collection: '',
    },
    createModal: false,
    renameModal: false,
    delCollectionModal: false,
    delTeamCollectionModal: false,

    renameItemModal: false,
    delItemModal: false,

    collectionName: '',
    collectionId: null,

    itemName: '',
    itemId: null,
    changeItem: null,

    selectedCollectionId: null,
    selectedCollectionName: null,
    selectedCollection: null,
    oneCollection: null,

    loading: false,
    printFiles: [],
    collumnCount: null,

    deletedItems: [],
  }),
  getters: {
    canSave: (state) => {
      const noName = state.printFiles.find(el => el.imgUrl && !el.name)
      if (noName) return false
      const isNew = !!state.printFiles?.find(el => el.imgUrl && !el.id && !el.error) || state.deletedItems.length
      let isOld = false
      state.printFiles.forEach(el => {
        if (el.id && state.items) {
          const print = state.items.find(e => e.id === el.id)
          let name = print?.name || ''
          if ((el.name !== name || el.imgUrl) && !el.error) isOld = true
        }
      })
      return isNew || isOld
    },
  },
  actions: {
    makeImgArray () {
      const isNotFull = this.printFiles.find(el => !el.imgUrl && !el.url)
      if (this.items && !isNotFull && !this.printFiles.length) {
        this.items.forEach(el => {
          this.printFiles.push({
            id: el.id,
            name: el.name,
            url: el.url,
            error: null,
            imgUrl: null,
          })
        })
      }
      if (!this.printFiles.length || !isNotFull) {
        const remainder = this.printFiles.length % this.collumnCount
        const needCount = remainder === 0 ? this.collumnCount : this.collumnCount - remainder
        this.printFiles.push(
          ...Array(needCount).fill(null).map(() => ({ imgUrl: null, name: '', error: null, id: null })),
        )
      }
    },
    addPrintImg (event, index) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.printFiles = [...this.printFiles]
          let id = this.printFiles[index].id ? this.printFiles[index].id : null
          this.printFiles[index] = {
            imgUrl: e.target.result,
            name: this.printFiles[index]?.name || '',
            url: this.printFiles[index]?.url,
            error: null,
            id: id,
            file,
          }
          this.makeImgArray()
        }
        reader.readAsDataURL(file)
      }
    },
    selectCollectionId (collectionId) {
      this.selectedCollectionId = collectionId
    },
    selectCollection (collection) {
      this.selectedCollection = collection
    },
    createModalToggle () {
      this.createModal = !this.createModal
      this.collectionName = ''
    },
    renameModalToggle () {
      this.renameModal = !this.renameModal
      this.collectionId = null
      this.collectionName = ''
    },
    delCollectionModalToggle () {
      this.delCollectionModal = !this.delCollectionModal
      this.collectionId = null
    },
    renameItemModalToggle () {
      this.renameItemModal = !this.renameItemModal
      this.itemId = null
      this.itemName = ''
    },
    delItemModalToggle () {
      this.delItemModal = !this.delItemModal
      this.itemId = null
    },
    async setSortOrderCollections (order) {
      this.collectionsParams.sortDirection = order
      await this.getList()
    },
    async searchByCollections (search) {
      this.collectionsParams.q = search
      this.collectionsParams.offset = 0
      await this.getList()
    },
    async sortCollection (sort) {
      this.collectionsParams.sortField = sort
      this.collectionsParams.offset = 0
      await this.getList()
    },
    async setSortOrderItems (order, id) {
      this.itemsParams.sortDirection = order
      this.itemsParams.offset = 0
      await this.getItems(id)
    },
    async searchByItems (search, id) {
      this.itemsParams.q = search
      this.itemsParams.offset = 0
      await this.getItems(id)
    },
    async sortItems (sort, id) {
      this.itemsParams.sortField = sort
      this.itemsParams.offset = 0
      await this.getItems(id)
    },
    async getList () {
      this.loading = true
      try {
        const { data: { rows: list, count } } = await request.get(
          '/surface/prints-collections',
          { params: this.collectionsParams },
        )
        this.list = list
        this.count = count
        this.loading = false
      } catch (e) {
        console.error(e.message)
        this.loading = false
      }
    },
    async getCollection (id) {
      try {
        const { data } = await request.get('/surface/prints-collections/' + id)
        this.oneCollection = data
      } catch (e) {
        console.error(e.message)
      }
    },
    async dellPrintImg (index) {
      const updatedFiles = [...this.printFiles]
      if (updatedFiles[index].id) this.deletedItems.push(updatedFiles[index].id)
      updatedFiles[index] = { imgUrl: null, name: '', error: null, id: null }
      this.printFiles = updatedFiles
      this.makeImgArray()
    },
    async savePrints (router) {
      this.loading = true
      if (this.deletedItems.length) {
        await request.delete(`/surface/prints/${this.deletedItems[0]}`)
        this.deletedItems.splice(0, 1)
        this.savePrints(router)
        return
      }
      for (let index = 0; index < this.printFiles.length; index++) {
        const item = this.printFiles[index]
        if (item.file && !item.id) {
          const form = new FormData()
          form.append('name', item.name)
          form.append('file', item.file)
          form.append('collection', this.selectedCollectionId)
          await request.post('/surface/prints',
            form,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              transformRequest: [(data) => data],
            })
            .then(response => {
              const updatedFiles = [...this.printFiles]
              updatedFiles[index] = {
                ...updatedFiles[index],
                id: response.data.id,
              }
              this.printFiles = updatedFiles
            })
            .catch(error => {
              const updatedFiles = [...this.printFiles]
              updatedFiles[index] = {
                ...updatedFiles[index],
                error: error.response.data.message,
              }
              this.printFiles = updatedFiles
            })
        } else if (item.id) {
          const print = this.items?.find(el => el.id === item.id)
          if (item.file || item?.name !== print?.name) {
            const form = new FormData()
            if (item.file) form.append('file', item.file)
            if (item?.name !== print?.name) form.append('name', item.name)
            await request.put('/surface/prints/' + item.id,
              form,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
                transformRequest: [(data) => data],
              })
              .catch(error => {
                const updatedFiles = [...this.printFiles]
                updatedFiles[index] = {
                  ...updatedFiles[index],
                  error: error.response.data.message,
                }
                this.printFiles = updatedFiles
                console.error('Error:', error)
              })
          }
        }
      }
      const isError = this.printFiles.find(el => el.error)
      this.loading = false
      if (!isError) router.push(`/user/surface-design-print/${this.selectedCollectionId}`)
    },
    clearFiles () {
      this.printFiles = []
      this.items = null
    },
    async create (router) {
      try {
        const response = await request.post(
          '/surface/prints-collections',
          JSON.stringify({ title: this.collectionName }),
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
            },
          },
        )
        this.createModalToggle()
        await this.getList()
        this.selectedCollectionId = response.data.id
        this.selectedCollectionName = response.data.title
        this.clearFiles()
        router.push({ name: 'surfaceDesignPrintNew' })
      } catch (e) {
        console.error(e.message)
      }
    },
    async updateCollection () {
      try {
        await request.put(
          '/surface/prints-collections/' + this.collectionId,
          JSON.stringify({ title: this.collectionName }),
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
            },
          },
        )
        await this.getList()
        this.renameModalToggle()
        this.collectionId = null
        this.collectionName = ''
      } catch (e) {
        console.error(e.message)
      }
    },
    async deleteCollection () {
      try {
        await request.delete('/surface/prints-collections/' + this.collectionId)
        await this.getList()
        this.delCollectionModalToggle()
        this.collectionId = null
      } catch (e) {
        console.error(e.message)
      }
    },

    async getItems (id) {
      try {
        this.itemsParams.collection = id
        const { data: { rows: items, count } } = await request.get(
          '/surface/prints',
          { params: this.itemsParams },
        )
        this.items = items
        this.itemsCount = count
      } catch (e) {
        console.error(e.message)
      }
    },

    async updateItem (collectionId) {
      try {
        await request.put(
          '/surface/prints/' + this.itemId,
          JSON.stringify({
            ...this.changeItem,
            designName: this.designName,
            designCategory: this.changeItem.categoryCode,
            elementIds: this.changeItem.elements.join(','),
            ease: JSON.stringify(this.changeItem.ease),
            fabricType: String(this.changeItem.fabricType),
            fit: String(this.changeItem.fit),
            collectionId: String(this.changeItem.collection),
            mannequinEase: JSON.stringify(this.changeItem.mannequinEase),
          }),
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
            },
          },
        )
        await this.getItems(collectionId)
        this.renameItemModalToggle()
        this.itemId = null
        this.itemName = ''
      } catch (e) {
        console.error(e.message)
      }
    },
    async deleteItem (collectionId) {
      try {
        await request.delete('/surface/prints/' + this.itemId)
        await this.getItems(collectionId)
        this.delItemModalToggle()
        this.itemId = null
      } catch (e) {
        console.error(e.message)
      }
    },
  },
})
